"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TSCast = /** @class */ (function () {
    function TSCast() {
    }
    TSCast.cast = function (object) {
        return object;
    };
    return TSCast;
}());
exports.default = TSCast;
//# sourceMappingURL=TSCast.js.map